import { Box, Typography, Button, CircularProgress } from "@mui/material";
import LightbulbTwoTone from "@mui/icons-material/LightbulbTwoTone";
import NoRecords from "components/NoRecords";
import { useNavigate } from "react-router-dom";
import { BasePathProvider, useBasePath } from "components/Providers";
import { useSelector } from "react-redux";
import GoalsList from "./List/EvaluationGoalsList";
import { useTranslation } from "react-i18next";

const EvaluationGoals = ({ goalsList }) => {
    const navigate = useNavigate();
    const baseUrl = useBasePath();
    const loading = useSelector(state => state.adminEvaluation.artifact.loading);
    const { t } = useTranslation();

    const boxStyles = {
        bgcolor: "background.paper",
        p: 2,
        borderRadius: 2.5,
        display: "flex",
        flexDirection: "column",
        minHeight: "200px",
        maxHeight: "400px",
        overflowY: "auto",
        overflowX: "auto",
    };

    const innerBoxStyles = {
        mt: 2,
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        flexGrow: 1,
    };
    const hasAdmin = goalsList?.some(goal => goal.adminEvaluationStandard?.name?.includes("Admin"));
    const hasGoal = goalsList?.some(goal => goal.adminEvaluationStandard?.name?.includes("iReady"));

    return (
        <BasePathProvider value={`${baseUrl}`}>
            <Box sx={{ ...boxStyles, flexGrow: 1 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">{t('My Goals')}</Typography>
                    <Box display="flex" gap={1}>
                        {!hasAdmin && (
                            <Button variant="contained" color="primary" size="small" onClick={() => navigate(`${baseUrl}/goal/new`, { state: { action: 'Admin' } })}>
                                {t('Set Admin Goal')}
                            </Button>
                        )}
                        {!hasGoal && (
                            <Button variant="contained" color="primary" size="small" onClick={() => navigate(`${baseUrl}/goal/new`, { state: { action: 'iReady' } })}>
                                {t('Set iReady Goal')}
                            </Button>
                        )}
                    </Box>
                </Box>
                {loading ? (
                    <Box sx={{ ...innerBoxStyles }}>
                        <CircularProgress size={50} />
                    </Box>
                ) : goalsList?.length > 0 ? (
                    <Box sx={{ ...innerBoxStyles, alignItems: "flex-start" }}>
                        <GoalsList goalsList={goalsList} />
                    </Box>
                ) : (
                    <Box sx={{ ...innerBoxStyles, mt: 0 }}>
                        <NoRecords
                            icon={<LightbulbTwoTone sx={{ fontSize: 50, color: "primary.main" }} />}
                            message={t("No Goals Yet")}
                        />
                    </Box>
                )}
            </Box>
        </BasePathProvider>
    );
};

export default EvaluationGoals;